import { useState } from 'react';
import OlMap from 'ol/Map';

import OpusLayer from 'lib/classes/opuslayer';

import { Popup, PopupProps } from 'lib/classes/popup';
import { assetURL } from 'lib/utilities/asset';
import { getLocaleString } from 'lib/localization/vendor';
import { getOpusLayerByCode } from 'lib/utilities/map';
import { updateURLParameter, matchFilter } from 'lib/utilities/misc';

import SearchResult from 'views/SearchResult';

import 'styles/css/PinDropSearchResults.scss';

const PinDropSearchResults = new Popup({
	title: () => getLocaleString('searchresult'),
	style: {width: "100%", maxWidth: 550, maxHeight: 900, height: "100%"},
	render: function() {
		const olMap:OlMap = this.get('map');
		const results:any[] = this.get('search-results');
		const onResultClicked:Function = this.get('result-clicked');
		
		const [filter, setFilter] = useState<string>('');
		
		const drawFilter = () => {
			return (
				<div className="pin-drop-sr-popup__search">
					<input 
						type='search' 
						placeholder={getLocaleString('search')}
						onChange={(e) => setFilter(e.target.value)} 
						value={filter}
						autoComplete='off'
					/>
				</div>
			)
		}
		const drawSearchResults = () => {
			const rows:any[] = [];
			
			results.forEach((result:any) => {
				const opusLayer:OpusLayer = getOpusLayerByCode(result.layerId, olMap);
				
				let url:string = result.image;
				
				const size:number = 40;
				
				url = updateURLParameter(url, 'width', size.toString());
				url = updateURLParameter(url, 'height', size.toString());
				
				if(filter && 
					!matchFilter(result.title, filter) && 
					!matchFilter(opusLayer.name, filter) &&
					!matchFilter(result.description, filter) && 
					!matchFilter(result.policies, filter) && 
					!matchFilter(result.urls, filter) && 
					!matchFilter(result.label, filter)
				)
					return;
				
				rows.push(
					<div className='layer-group__layer' onClick={() => onResultClicked?.(result)}>
						<div className='layer-row__meta'>
							<div className='layer-row__image'>
								<img src={url} /> 
							</div>
							<div className='layer-row__title' title={getLocaleString('inforesult')}>
								{result.title || getLocaleString('notitle')}
								<div className='layer-row__subtitle'>
									{opusLayer.name}
								</div>
							</div>
						</div>
						<div className='pin-drop-sr-popup__content'>
							<SearchResult 
								key={rows.length} 
								olMap={olMap} 
								result={result} 
								title={result.title} 
							/>
						</div>
					</div>
				)
				
			});
			
			return rows;
		}
		
		return (
			<div className='pin-drop-sr-popup'>
				<div className="pin-drop-sr-popup__search--shroud"></div>
				{drawFilter()}
				<div className='pin-drop-sr-popup__container'>
					{drawSearchResults()}
				</div>
			</div>
		);
	}
});

export default PinDropSearchResults;